module.exports = __webpack_public_path__ + "img/palette_konfigurierbar_vektorisiert.b43942b.svg";